import { useRef } from 'react';
import SockJsClient from 'react-stomp';
import Config from 'utils/Config';
import { identifiers } from 'utils/constants/identifiers';
import { fetchFromStorage } from 'utils/storage';

const WebSocket = ({ handleNotification, tenantId }) => {
  let webSocket = useRef();
  const token = fetchFromStorage(identifiers.access_token);

  const disconnect = error => {
    console.error(`[WebSocket] Disconnected due to error: ${error.message || error}`);
    webSocket?.disconnect();
  };

  return (
    <SockJsClient
      autoReconnect
      url={`${Config.BaseURL}/websocket`}
      headers={{ Authorization: `Bearer ${token}` }}
      topics={[`/topic/bookings/${tenantId}`, `/user/queue/bookings/${tenantId}`]}
      onConnect={() => console.info('[WebSocket] Connected')}
      onMessage={(message, topic) => {
        console.info(`[WebSocket] Message received on topic "${topic}":`, message);
        handleNotification(message, topic);
      }}
      onDisconnect={() => console.info('[WebSocket] Disconnected')}
      onConnectFailure={error => {
        console.error(`[WebSocket] Connection failed:`, error);
        disconnect(error);
      }}
      ref={el => (webSocket = el)}
    />
  );
};
export default WebSocket;
